<div class="modal-header modal-block-primary">
  <button type="button" class="close" (click)="modalRef.hide()">
    <span aria-hidden="true">&times;</span>
    <span class="sr-only">Close</span>
  </button>
  <h4 class="modal-title">Delete</h4>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-md-12"></div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <input
        type="text"
        [(ngModel)]="this.remitDeleteReason"
        class="form-control"
        placeholder="Provide reason to delete"
      />
    </div>
  </div>
</div>
<div class="modal-footer">
  <button
    type="button"
    [disabled]="this.remitDeleteReason === ''"
    class="btn btn-primary"
    (click)="deleteRemittance($event)"
  >
    Ok
  </button>
  <button type="button" class="btn btn-default" data-dismiss="modal" (click)="modalRef.hide()">
    Cancel
  </button>
</div>
